<template>
  <div class="c-app-search-bar" :class="{ action: searchActive }">
    <div class="input__wrapper">
      <el-input
        size="small"
        class="input"
        style="min-width: 100px"
        placeholder="请输入菜单名称"
        readonly
        @click="handleInputClick"
      >
        <template #suffix>
          <el-icon :size="18" color="white" class="input__icon"><SearchIcon /></el-icon>
        </template>
      </el-input>
    </div>

    <CAppOverlay v-if="isOpen" ref="overlayRef" @hide="handleOverlayHide">
      <component v-if="searchComponent" :is="searchComponent" @hide="handleSearchPanelHide" />
    </CAppOverlay>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, useHostAppInstance } from '@zto/zpage'
import { ElementPlusIcons } from '@zto/zpage-ui-element'

import CAppOverlay from '../overlay/CAppOverlay.vue'

const { Search: SearchIcon } = ElementPlusIcons

const app = useHostAppInstance()

const searchConfig = app.useAppConfig('header.search', {})

const searchComponent = searchConfig.component || app.resolveComponent('CAppSearchPanel')

const isOpen = ref<boolean>(false)

function handleInputClick() {
  isOpen.value = true
}

function handleOverlayHide() {
  isOpen.value = false
}
function handleSearchPanelHide() {
  isOpen.value = false
}
</script>

<style lang="scss" scoped>
.c-app-search-bar {
  opacity: 0.5;

  &.active {
    opacity: 1;
  }

  &:hover {
    opacity: 0.8;
  }
}

.input {
  :deep(.el-icon) {
    padding: 6px 5px;

    &:hover {
      color: white;
    }
  }

  :deep(input) {
    background: transparent;
    cursor: pointer;
    border-color: white;

    &::placeholder {
      color: white;
    }
  }
}
</style>
